import React from 'react'
import { Dialog, DialogTitle, DialogContent, Box, Typography, DialogActions, Button, Divider } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing, palette }) => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  helpIcon: {
    color: palette.text.hint,
    width: spacing(2),
    marginLeft: spacing(1)
  }
}))

export const ElearningPreviewModal = ({ open, setOpen, entity }) => {
  console.log('Elearning Preview Modal Rendering...')
  const classes = useStyles()

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle className={classes.titleContainer} data-test='elearning-preview-title'>
        Elearning Content
        <HelpOutlineIcon className={classes.helpIcon} />
      </DialogTitle>
      <Divider variant='middle' />
      <DialogContent data-test='elearning-preview-text'>
        <Box>
          <Typography>
            You are currently in a preview mode for the Elearning. Clicking the 'Start Here' Button in the live site will initiate the <strong>{entity.data.title}</strong> learning content. However, in this preview mode, this button is disabled for demonstration purposes.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleClose}
          color='primary'
          data-test='elearning-preview-button-close'
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}
